import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Card,
  CardBody,
  CardHeader,
  Heading,
  useDisclosure,
  Text,
  Spacer,
  Input,
  Image,
  useToast,
} from "@chakra-ui/react";
import { ConfirmModal } from "../components";
import { useGlobal } from "../contexts/Globals";
import { AppAction, IHeSoDieuChinh } from "../_types_";
import {
  themMoiHeSoDieuChinh,
  layDanhSachHeSoDieuChinh,
} from "../apis/he.so.dieu.chinh.api";
import { getToast } from "../utils";
import { DeleteIcon, EditIcon, NotAllowedIcon } from "@chakra-ui/icons";
import SearchContainer from "../components/SearchContainer";

const Vungs = ["vung1", "vung2", "vung3", "vung4", "vung5"];

export default function HeSoDieuChinh() {
  const toast = useToast();
  const { loaiDats, isHasEditRole } = useGlobal();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [, setModel] = useState<IHeSoDieuChinh[]>();
  const [heSoDieuChinhS, setHeSoDieuChinhS] = useState<IHeSoDieuChinh[]>([]);
  const [mdsd, setMdsd] = useState<string>();

  /**
   * Lấy danh sách hệ số điều chỉnh từ api
   */
  const fetchHeSoDieuChinh = useCallback(
    async (isHis?: boolean, keySearch?: string) => {
      try {
        const rs = await layDanhSachHeSoDieuChinh(1, 100, isHis, keySearch);
        setHeSoDieuChinhS(rs);
      } catch (ex) {
        toast(getToast("Đã có lỗi xảy ra, vui lòng thử lại sau."));
      }
    },
    [toast]
  );

  const getInitialData = useCallback(() => {
    const rs = loaiDats.map((loai) => {
      const hsdc: IHeSoDieuChinh = {
        mdsd: loai.value as string,
        doThi: {
          vung1: 10,
          vung2: 10,
          vung3: 2,
          vung4: 3,
          vung5: 4,
        },
        nongThon: {
          vung1: 1,
          vung2: 2,
          vung3: 3,
          vung4: 4,
          vung5: 5,
        },
        isDeleted: false,
        action: AppAction.ADD,
      };
      return hsdc;
    });
    setModel(rs);
  }, [loaiDats]);

  const handleChangeValue = useCallback(
    (
      mdsd: string,
      kv: string,
      val: number | string,
      type: "doThi" | "nongThon"
    ) => {
      const mdsdIndex = heSoDieuChinhS.findIndex((p) => p.mdsd === mdsd);
      if (mdsdIndex > -1) {
        const m = [...heSoDieuChinhS];
        if (m[mdsdIndex][type]) {
          //@ts-ignore
          m[mdsdIndex][type][kv] = val;
        }
        setModel(m);
      }
    },
    [heSoDieuChinhS]
  );

  useEffect(() => {
    getInitialData();
  }, [getInitialData]);

  useEffect(() => {
    fetchHeSoDieuChinh();
  }, [fetchHeSoDieuChinh]);

  const handleSaveChange = async (type: AppAction) => {
    try {
      if (mdsd) {
        const item = heSoDieuChinhS.find((p) => p.mdsd === mdsd);
        if (item) {
          item.action =
            type === AppAction.DELETE
              ? AppAction.DELETE
              : item.doThi?.id !== 0
              ? AppAction.EDIT
              : AppAction.ADD;
          await themMoiHeSoDieuChinh([item]);
        }
        await fetchHeSoDieuChinh();
        toast(getToast("Thành công", "success", "Thành công"));
      }
    } catch (er) {
      toast(getToast("Đã có lỗi xảy ra, vui lòng thử lại sau."));
    }
    onClose();
    setMdsd(undefined);
  };

  return (
    <Flex w="full" bg="whiteAlpha.900">
      <Card w="full">
        <CardHeader>
          <Flex>
            <Heading as="h3" textTransform="uppercase">
              Hệ Số Điều Chỉnh
            </Heading>
            <Spacer />
          </Flex>
          <Flex w="full" mt="20px">
            <SearchContainer
              placeholder="Tìm kiếm theo mđsd"
              onSearch={(s, isHis) => fetchHeSoDieuChinh(isHis, s)}
            />
            <Spacer />
            {mdsd && (
              <Button
                bg="green"
                size="sm"
                onClick={() => handleSaveChange(AppAction.ADD)}
                ml="10px"
              >
                <Image src="./imgs/save.png" />
                <Text ml="10px" color="white">
                  Lưu thay đổi
                </Text>
              </Button>
            )}
          </Flex>
        </CardHeader>
        <CardBody>
          <Flex w="full" overflowY="scroll">
            <TableContainer w="full">
              <Table variant="simple" className="tbl-hsdc">
                <Thead>
                  <Tr>
                    <Th rowSpan={2}>Mục đích sử dụng</Th>
                    <Th colSpan={5} textAlign="center" bg="blue.50">
                      Nông thôn
                    </Th>
                    <Th colSpan={5} textAlign="center" bg="yellow.50">
                      Đô thị
                    </Th>
                    <Th rowSpan={2} colSpan={2} w="100px" bg="gray.50"></Th>
                  </Tr>
                  <Tr>
                    <Th bg="blue.50">KV1</Th>
                    <Th bg="blue.50">KV2</Th>
                    <Th bg="blue.50">KV3</Th>
                    <Th bg="blue.50">KV4</Th>
                    <Th bg="blue.50">KV5</Th>
                    <Th bg="yellow.50">KV1</Th>
                    <Th bg="yellow.50">KV2</Th>
                    <Th bg="yellow.50">KV3</Th>
                    <Th bg="yellow.50">KV4</Th>
                    <Th bg="yellow.50">KV5</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {heSoDieuChinhS.map((hsdc, index) => {
                    const isSelected = mdsd && hsdc.mdsd === mdsd;
                    return (
                      <Tr
                        key={`${hsdc.mdsd}-${index}`}
                        className={`${isSelected ? "tr-selected" : ""}`}
                      >
                        <Td>
                          <Flex>
                            {loaiDats.find((p) => p.value === hsdc.mdsd)?.lable}
                          </Flex>
                        </Td>
                        {Vungs.map((vung) => (
                          <Td
                            bg="blue.50"
                            key={`nong-thon-${hsdc.mdsd}-${vung}`}
                          >
                            <Input
                              bg="white"
                              readOnly={!isSelected}
                              isDisabled={!isSelected}
                              value={
                                //@ts-ignore
                                (hsdc.nongThon && hsdc.nongThon[vung]) || 0
                              }
                              type="number"
                              fontSize="12px"
                              padding="0px"
                              textAlign="center"
                              border="1px solid #333"
                              onChange={(e) =>
                                handleChangeValue(
                                  hsdc.mdsd as string,
                                  vung,
                                  e.target.value,
                                  "nongThon"
                                )
                              }
                            />
                          </Td>
                        ))}
                        {Vungs.map((vung) => (
                          <Td
                            bg="yellow.50"
                            key={`do-thi-${hsdc.mdsd}-${vung}`}
                          >
                            <Input
                              bg="white"
                              readOnly={!isSelected}
                              isDisabled={!isSelected}
                              //@ts-ignore
                              value={(hsdc.doThi && hsdc.doThi[vung]) || 0}
                              type="number"
                              fontSize="12px"
                              padding="0px"
                              textAlign="center"
                              onChange={(e) =>
                                handleChangeValue(
                                  hsdc.mdsd as string,
                                  vung,
                                  e.target.value,
                                  "doThi"
                                )
                              }
                            />
                          </Td>
                        ))}
                        {isHasEditRole && (
                          <Td>
                            <Button
                              bg="red.300"
                              size="sm"
                              onClick={() => {
                                onOpen();
                                setMdsd(hsdc.mdsd);
                              }}
                            >
                              <DeleteIcon color="white" />
                            </Button>
                            <Button
                              bg={`${isSelected ? "gray.300" : "blue.300"}`}
                              size="sm"
                              ml="5px"
                              onClick={() => {
                                if (isSelected) {
                                  setMdsd(undefined);
                                } else setMdsd(hsdc.mdsd);
                              }}
                            >
                              {!isSelected && <EditIcon color="white" />}
                              {isSelected && <NotAllowedIcon />}
                            </Button>
                          </Td>
                        )}
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
        </CardBody>
      </Card>
      <ConfirmModal
        isOpen={isOpen}
        onClose={() => {
          setMdsd(undefined);
          onClose();
        }}
        onOk={() => handleSaveChange(AppAction.DELETE)}
      />
    </Flex>
  );
}
